module.exports = "https://r.nearpod.com/assets/media/image/3d-44a9c9e48be56c4e12d3d40ba36151bc.svg";